import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { useContactInfo } from 'src/contexts/ContactContext';

const messages = defineMessages({
    readonlyInfo: {
        id: 'readonlyInfo',
        defaultMessage: 'A naptár csak tájékoztató jellegű.'
    },
    readonlyInfoCallText: {
        id: 'readonlyInfoCallText',
        defaultMessage: 'Foglaláshoz hívd a következő telefonszámot:'
    },
    readonlyModifyInfo: {
        id: 'readonlyModifyInfo',
        defaultMessage: 'A foglalás online nem módosítható.'
    },
    readonlyModifyInfoCallText: {
        id: 'readonlyModifyInfoCallText',
        defaultMessage: 'Amennyiben módosítani vagy törölni szeretnéd a foglalásod, hívd a következő számot:'
    },
    readonlyInfoCallAction: {
        id: 'readonlyInfoCallAction',
        defaultMessage: 'Hívás'
    },
});

interface IReadonlyInfoProps {
    phoneNumber?: string;
    isModify?: boolean;
    className?: string;
}

export const ReadonlyInfo: React.FC<IReadonlyInfoProps> = ({ phoneNumber, isModify, className }) => {
    const { PublicPhoneNumber } = useContactInfo();

    if (!phoneNumber) {
        phoneNumber = PublicPhoneNumber ?? undefined;
    }

    const info = isModify ? messages.readonlyModifyInfo : messages.readonlyInfo;
    const infoCallText = isModify ? messages.readonlyModifyInfoCallText : messages.readonlyInfoCallText;

    return (
        <section className={`readonly ${isModify ? 'readonly--modify' : ''} ${className}`}>
            <span className="readonly__info">
                <FormattedMessage {...info} />
            </span>
            {phoneNumber &&
                <>
                    <FormattedMessage {...infoCallText} />
                    <div className="readonly__phone">
                        <span className="readonly__phone-text">{phoneNumber}</span>
                        <a href={`tel:${phoneNumber}`} className="button button--primary readonly__phone-link">
                            <FormattedMessage {...messages.readonlyInfoCallAction} />
                        </a>
                    </div>
                </>
            }
        </section>
    );
}